// src/IconXmarkFill.tsx
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
var Icon = ({
  size = 24,
  ...props
}, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-seed-icon": "true",
    "data-seed-icon-version": "0.0.23",
    width: size,
    height: size,
    ref,
    ...props,
    children: /* @__PURE__ */ jsx("g", { children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.35055 21.0505C3.82055 21.5205 4.58055 21.5205 5.05055 21.0505L12.2005 13.9005L19.3505 21.0505C19.8205 21.5205 20.5805 21.5205 21.0505 21.0505C21.5205 20.5805 21.5205 19.8205 21.0505 19.3505L13.9005 12.2005L21.0505 5.05055C21.5205 4.58055 21.5205 3.82055 21.0505 3.35055C20.5805 2.88055 19.8205 2.88055 19.3505 3.35055L12.2005 10.5005L5.05055 3.35055C4.58055 2.88055 3.82055 2.88055 3.35055 3.35055C2.88055 3.82055 2.88055 4.58055 3.35055 5.05055L10.5005 12.2005L3.35055 19.3505C2.88055 19.8205 2.88055 20.5805 3.35055 21.0505Z",
        fill: "currentColor"
      }
    ) })
  }
);
var IconXmarkFill = forwardRef(Icon);
var IconXmarkFill_default = IconXmarkFill;
export {
  IconXmarkFill_default as default
};
